"use strict";
// Copyright © 2022-2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarId = exports.caldavIntegrationKind = exports.calendarIntegrationKind = exports.AccessLevel = void 0;
const platform_1 = require("@hcengineering/platform");
var AccessLevel;
(function (AccessLevel) {
    AccessLevel["FreeBusyReader"] = "freeBusyReader";
    AccessLevel["Reader"] = "reader";
    AccessLevel["Writer"] = "writer";
    AccessLevel["Owner"] = "owner";
})(AccessLevel || (exports.AccessLevel = AccessLevel = {}));
/**
 * @public
 */
exports.calendarIntegrationKind = 'google-calendar';
/**
 * @public
 */
exports.caldavIntegrationKind = 'caldav';
/**
 * @public
 */
exports.calendarId = 'calendar';
/**
 * @public
 */
const calendarPlugin = (0, platform_1.plugin)(exports.calendarId, {
    class: {
        Calendar: '',
        ExternalCalendar: '',
        Event: '',
        ReccuringEvent: '',
        ReccuringInstance: '',
        Schedule: '',
        BusySlot: '',
        PrimaryCalendar: ''
    },
    mixin: {
        CalendarEventPresenter: ''
    },
    icon: {
        Calendar: '',
        CalendarView: '',
        Location: '',
        Reminder: '',
        Notifications: '',
        Watch: '',
        Description: '',
        Participants: '',
        Repeat: '',
        Globe: '',
        Public: '',
        Hidden: '',
        Private: '',
        Duration: '',
        Timer: ''
    },
    image: {
        Permissions: ''
    },
    space: {
        Calendar: ''
    },
    app: {
        Calendar: ''
    },
    component: {
        CreateEvent: '',
        EditEvent: '',
        CalendarView: '',
        PersonsPresenter: '',
        Events: '',
        DateTimePresenter: '',
        DocReminder: '',
        ConnectApp: '',
        ScheduleEditor: '',
        IntegrationState: ''
    },
    string: {
        Title: '',
        Calendar: '',
        Description: '',
        Date: '',
        DueTo: '',
        Calendars: '',
        CreateCalendar: '',
        Location: '',
        Participants: '',
        NoParticipants: '',
        PersonsLabel: '',
        EventNumber: '',
        Reminders: '',
        Today: '',
        Visibility: '',
        Public: '',
        FreeBusy: '',
        Busy: '',
        Private: '',
        NotAllPermissions: '',
        Value: '',
        Schedule: '',
        ScheduleNew: '',
        ScheduleDeleteConfirm: '',
        ScheduleShareLink: '',
        ScheduleSharedLinkMessage: '',
        CopyLink: '',
        ScheduleAvailability: '',
        ScheduleAddPeriod: '',
        ScheduleRemovePeriod: '',
        ScheduleTitlePlaceholder: '',
        ScheduleUnavailable: '',
        MeetingDuration: '',
        MeetingInterval: '',
        Day: '',
        Week: '',
        Month: '',
        CalDavAccess: '',
        CalDavAccessPrompt: '',
        CalDavAccessEnable: '',
        CalDavAccessServer: '',
        CalDavAccessAccount: '',
        CalDavAccessPassword: '',
        CalDavAccessPasswordWarning: '',
        MeetingScheduledNotification: '',
        MeetingRescheduledNotification: '',
        MeetingCanceledNotification: '',
        SynchronizedCalendars: '',
        Account: '',
        NoCalendars: '',
        PersonalCalendar: ''
    },
    handler: {
        DisconnectHandler: '',
        DisconnectAllHandler: ''
    },
    integrationType: {
        Calendar: ''
    },
    metadata: {
        CalendarServiceURL: '',
        PublicScheduleURL: '',
        CalDavServerURL: ''
    },
    extensions: {
        EditEventExtensions: '',
        EditScheduleExtensions: ''
    },
    ids: {
        ReminderNotification: '',
        NoAttached: ''
    },
    function: {
        ConfigureCalDavAccess: '',
        EventTitleProvider: ''
    }
});
exports.default = calendarPlugin;
__exportStar(require("./utils"), exports);
//# sourceMappingURL=index.js.map